import { render } from "./InventoryPlanOrderSuppliers.vue?vue&type=template&id=66b25a92"
import script from "./InventoryPlanOrderSuppliers.vue?vue&type=script&lang=js"
export * from "./InventoryPlanOrderSuppliers.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__